export const NOT_IMPLEMENTED = { code: '0', message: 'Method not implemented.' };
